module.exports = __webpack_public_path__ + "static/media/history.681faca6.webp";